import React, { useState, useEffect } from 'react';
import useMeta from '../../../hooks/useMeta';

import Navbar from '../../../CommonComponent/Navbar/Navbar';
import Footer from '../../../CommonComponent/Footer/footer';
import NotificationBar from '../../../CommonComponent/Notification/NotificationBar';

import './ProductPageUI.css';
import { useParams, Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { productData } from '../ProductData';


const ProductPageUI = () => {
    const { productId } = useParams();
    const data = productData[productId];

    const Showcaseimg = data.fabrics?.thumbnails?.[0]?.replace(/\.webp$/, '-Shocase.webp') || '';

    const META_PG_OG_Title = data?.META_PG_OG_Title || '';
    const META_PG_OG_Description = data?.META_PG_OG_Description || '';
    const META_PG_Canonical_OG_URL = data?.META_PG_Canonical_OG_URL || '';

    useMeta({
        title: `${META_PG_OG_Title}`,
        description: `${META_PG_OG_Description}`,
        canonical: `${META_PG_Canonical_OG_URL}`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: `${META_PG_OG_Title}`,
            description: `${META_PG_OG_Description}`,
            url: `${META_PG_Canonical_OG_URL}`,
            site_name: 'Callistus Blinds',
        },
    });


    const [activeTab, setActiveTab] = useState('Inspiration');
    const [selectedFabric, setSelectedFabric] = useState(Showcaseimg);

    useEffect(() => {
        if (data.fabrics?.thumbnails?.length) {
            data.fabrics.thumbnails.forEach((img) => {
                const urlParts = img.split('.');
                const extension = urlParts.pop();
                const baseUrl = urlParts.join('.');
                const showcaseUrl = `${baseUrl}-Shocase.${extension}`;

                const preloadImg = new Image();
                preloadImg.src = showcaseUrl;
            });
        }
    }, [data.fabrics]);


    const handleFabricSelect = (img) => {
        const urlParts = img.split('.');
        const extension = urlParts.pop();
        const baseUrl = urlParts.join('.');
        const showcaseUrl = `${baseUrl}-Shocase.${extension}`;
        setSelectedFabric(showcaseUrl);
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    return (
        <>
            <Navbar />
            <NotificationBar />

            <div className="colby-blinds-container">
                {/* Hero Slider */}
                {data.heroSlider?.images?.length > 0 && (
                    <div className="P-hero-slider-container">
                        <Swiper
                            modules={[Navigation, Autoplay]}
                            loop={true}
                            autoplay={{ delay: 5000 }}
                            navigation={{
                                nextEl: '.P-hero-next',
                                prevEl: '.P-hero-prev',
                            }}
                            className="P-hero-slider"
                        >
                            {data.heroSlider.images.map((img, index) => (
                                <SwiperSlide key={index}>
                                    <div className="P-hero-slide">
                                        <img
                                            src={img}
                                            alt={`Slide ${index}`}
                                            className="P-hero-slide-img"
                                            loading="lazy"
                                        />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <button className="P-hero-prev">&#10094;</button>
                        <button className="P-hero-next">&#10095;</button>
                    </div>
                )}

                {/* Main Content */}
                <div className="main-content">
                    {/* Left Column */}
                    <div className="left-column">
                        <h1>{data.name}</h1>

                        {/* Tabs */}
                        <div className="tab-navigation">
                            {['Inspiration', 'Overview', 'Operating Systems', 'Solutions'].map((tab) => (
                                <button
                                    key={tab}
                                    className={`tab-btn ${activeTab === tab ? 'active' : ''}`}
                                    onClick={() => handleTabChange(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>

                        {/* Tab Content */}
                        <div className="tab-content">
                            {/* Inspiration */}
                            {activeTab === 'Inspiration' && data.inspirationSlider && (
                                <>
                                    {data.inspirationSlider.images?.length > 0 && (
                                        <div className="inspiration-slider-container">
                                            <Swiper
                                                modules={[Navigation, Autoplay]}
                                                loop={true}
                                                autoplay={{ delay: 5000 }}
                                                navigation={{
                                                    nextEl: '.inspiration-next',
                                                    prevEl: '.inspiration-prev',
                                                }}
                                                className="inspiration-slider"
                                            >
                                                {data.inspirationSlider.images.map((img, index) => (
                                                    <SwiperSlide key={index}>
                                                        <div className="inspiration-slide">
                                                            <img
                                                                src={img}
                                                                alt={`Inspiration ${index}`}
                                                                className="inspiration-slide-img"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    </SwiperSlide>
                                                ))}
                                            </Swiper>
                                            <button className="inspiration-prev">&#10094;</button>
                                            <button className="inspiration-next">&#10095;</button>
                                        </div>
                                    )}

                                    {data.inspirationSlider.text?.length > 0 && (
                                        <div className="inspiration-text">
                                            {data.inspirationSlider.text.map((paragraph, index) => (
                                                <div key={index}>{paragraph}</div>
                                            ))}
                                        </div>
                                    )}
                                </>
                            )}

                            {/* Overview */}
                            {activeTab === 'Overview' && data.overview && (
                                <>
                                    {data.overview.text?.length > 0 && (
                                        <div className="overview-text">
                                            {data.overview.text.map((paragraph, index) => (
                                                <div key={index}>{paragraph}</div>
                                            ))}
                                        </div>
                                    )}

                                    {data.overview.specs?.length > 0 && (
                                        <div className="specs-table">
                                            {data.overview.specs.map((spec, index) => (
                                                <div key={index} className="spec-row">
                                                    <div className="spec-label">{spec.label}</div>
                                                    <div className="spec-value">{spec.value}</div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {data.overview.video && (
                                        <div className="video-container">
                                            <iframe
                                                width="560"
                                                height="315"
                                                src={data.overview.video}
                                                title="YouTube video player"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                referrerPolicy="strict-origin-when-cross-origin"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    )}

                                    {data.overview.videoButton && (
                                        <div className="Overview-btn-align">
                                            <Link to="/videos-gallery" className="more-videos-btn">{data.overview.videoButton}</Link>
                                        </div>
                                    )}
                                </>
                            )}

                            {/* Operating Systems */}
                            {activeTab === 'Operating Systems' &&
                                data.operatingSystems?.systems?.length > 0 && (
                                    <div className="systems-container">
                                        <h2>{data.operatingSystems.title}</h2>
                                        {data.operatingSystems.systems.map((system, index) => (
                                            <div key={index} className="system-card">
                                                <div className="system-image">
                                                    <p>{system.title}</p>
                                                    {system.image != null && (
                                                        <img src={system.image} alt={system.title} />
                                                    )}
                                                </div>
                                                <div className="system-content">
                                                    <p>{system.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                            {/* Solutions */}
                            {activeTab === 'Solutions' && data.solutions && (
                                <>
                                    {data.solutions.text?.length > 0 && (
                                        <div className="solutions-text">
                                            {data.solutions.text.map((paragraph, index) => (
                                                <p key={index}>{paragraph}</p>
                                            ))}
                                        </div>
                                    )}

                                    {data.solutions.combinations?.length > 0 && (
                                        <div className="solutions-container">
                                            {data.solutions.combinations.map((solution, index) => (
                                                <div key={index} className="solution-card">
                                                    <p className="solution-c-title">{solution.title}</p>
                                                    <div className="solution-content">
                                                        {solution.image != null && (
                                                            <div className="solution-image">
                                                                <img src={solution.image} alt={solution.title} />
                                                            </div>
                                                        )}
                                                        <div className="solution-description">
                                                            <div><p>{solution.description}</p></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="right-column">
                        {data.fabrics && (
                            <div className="fabric-showcase">
                                {selectedFabric && (
                                    <img src={selectedFabric} alt="Selected Fabric" className="main-fabric-image" />
                                )}

                                {data.fabrics.title && <h3>{data.fabrics.title}</h3>}

                                {data.fabrics.thumbnails?.length > 0 && (
                                    <div className="fabric-thumbnails-grid">
                                        {data.fabrics.thumbnails.map((img, index) => (
                                            <img
                                                key={index}
                                                src={img}
                                                alt={`Fabric ${index + 1}`}
                                                onClick={() => handleFabricSelect(img)}
                                                className="fabric-thumbnail"
                                            />
                                        ))}
                                    </div>
                                )}

                                {data.fabrics.viewMoreButton && (
                                    <Link to={data.fabrics.ViewMoreLink} className="view-more-btn">{data.fabrics.viewMoreButton}</Link>
                                )}

                                {data.fabrics.description && (
                                    <p className="fabric-description">{data.fabrics.description}</p>
                                )}

                                {data.fabrics.galleryButton && (
                                    <Link to="/contact" className="nearest-gallery-btn">{data.fabrics.galleryButton}</Link>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default ProductPageUI;
